<div #buttonToLinkPopover class="w-fit">
  <pl-button class="!w-fit" [padding]="ButtonPadding.small" [variant]="ButtonVariant.lightOrange" (click)="openMenu()">
    <span>Download</span>
    <pl-icon
      [name]="PlIcon.chevron_forward"
      class="text-inherit transition-all transform duration-150 w-5 h-5"
      [ngClass]="{
        '-rotate-90': showMenu(),
        'rotate-90': !showMenu()
      }"
    />
  </pl-button>
</div>

<pl-popover
  [show]="showMenu()"
  [positionX]="PositionX.end"
  [positionY]="PositionY.below"
  (dismissed)="closeMenu()"
  [bindingElement]="buttonToLinkPopover"
>
  <div @opacity *ngIf="showMenu()">
    <pl-button
      *ngFor="let menuItem of menuItems()"
      class="border-b border-b-pl-gray-400 last-of-type:border-none"
      [variant]="ButtonVariant.transparent"
      (click)="onMenuItemClicked(menuItem)"
    >
      {{ menuItem.label }}
    </pl-button>
  </div>
</pl-popover>
